import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_LoopOptimizations = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Loop optimizations & Principal Sources of Optimization"
    videos={[
      "https://www.youtube.com/embed/yHZFVz6TVmI",
      "https://www.youtube.com/embed/Hn0iOYV385g",
    ]}
    takeaways={[]}
    questions={[
      "How can loop optimization techniques, such as loop unrolling improve the performance of programs in compiler design? Can you provide an example and explain the process of loop unrolling in detail?",
      `Consider the following nested loop in a matrix multiplication function. Identify and discuss three loop optimization techniques that can be applied to improve the performance of this function. Explain how each technique would specifically enhance the execution efficiency. Illustrate the impact of these optimizations on the computational complexity of the function. Would they affect the time complexity, space complexity, or both? Provide a detailed analysis.

void matrix_multiply(int A[100] [100], int B[100] [100], int C[100] [100]) { 
for (int i = 0; i < 100; i++) { 
for (int j = 0; j < 100; j++) { 
c[i][j] = 0; 
for (int k=0; k < 100; k++) 
{ c[i][j] += A[i][k] * B[k][j]; }
}}}
`,
      `Optimize the following code using various optimization Techniques: 

i=1;s=0; 
x=5;y=7; 
for(i=1;i <= n; i++) 
for(j=1;j <= 3;j++) 
c[i][j]=c[i][j]+a[i][j]+b[i][j];
C[i][j]=x-y; `
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_LoopOptimizations;
